import { Category } from '../types';

export const SERVICE_CATEGORIES: Category[] = [
  {
    id: 'repair',
    title: 'Ремонт и тех. работы',
    iconName: 'Wrench',
    iconAsset: '/assets/icons/cat_repair.svg',
    services: [
      { id: 'leak', name: 'Устранение протечки', minPrice: 1500, maxPrice: 4000 },
      { id: 'clog', name: 'Прочистка засора', minPrice: 1500, maxPrice: 4000 },
      { id: 'mixer', name: 'Замена смесителя', minPrice: 1200, maxPrice: 3000 },
      { id: 'toilet', name: 'Установка унитаза / раковины', minPrice: 1500, maxPrice: 3000 },
      { id: 'socket', name: 'Замена розетки / выключателя', minPrice: 1200, maxPrice: 2500 },
      { id: 'diagnostic', name: 'Диагностика неисправности', minPrice: 1000, maxPrice: 3000 },
      { id: 'other_repair', name: 'Другая проблема', minPrice: 0, maxPrice: 0 },
    ],
  },
  {
    id: 'furniture',
    title: 'Мебель и интерьер',
    iconName: 'Armchair',
    iconAsset: '/assets/icons/cat_furniture.svg',
    services: [
      { id: 'closet', name: 'Сборка шкафа', minPrice: 1500, maxPrice: 4000 },
      { id: 'kitchen', name: 'Сборка кухонного гарнитура', minPrice: 3000, maxPrice: 6000 },
      { id: 'bed', name: 'Сборка кровати', minPrice: 1200, maxPrice: 2500 },
      { id: 'table', name: 'Сборка стола / комода', minPrice: 1200, maxPrice: 2500 },
      { id: 'disassemble', name: 'Разборка мебели', minPrice: 800, maxPrice: 2500 },
      { id: 'mount_furniture', name: 'Крепление мебели к стене', minPrice: 1000, maxPrice: 2000 },
      { id: 'other_furniture', name: 'Другая услуга по мебели', minPrice: 0, maxPrice: 0 },
    ],
  },
  {
    id: 'walls',
    title: 'Стены, потолки, пол',
    iconName: 'BrickWall',
    iconAsset: '/assets/icons/cat_walls.svg',
    services: [
      { id: 'drilling', name: 'Сверление отверстий', minPrice: 100, maxPrice: 300, unit: 'шт' },
      { id: 'mounting_tv', name: 'Навес ТВ / зеркала / картин', minPrice: 1500, maxPrice: 4000 },
      { id: 'cornice', name: 'Установка карнизов', minPrice: 1200, maxPrice: 3000 },
      { id: 'plinth', name: 'Установка плинтусов', minPrice: 1000, maxPrice: 2500 },
      { id: 'tile', name: 'Замена плитки (1–2 шт)', minPrice: 1500, maxPrice: 3500 },
      { id: 'other_walls', name: 'Другие работы со стенами', minPrice: 0, maxPrice: 0 },
    ],
  },
  {
    id: 'windows',
    title: 'Окна и двери',
    iconName: 'DoorOpen',
    iconAsset: '/assets/icons/cat_windows.svg',
    services: [
      { id: 'adjust', name: 'Регулировка окон / дверей', minPrice: 1000, maxPrice: 3000 },
      { id: 'sealing', name: 'Замена уплотнителей', minPrice: 1200, maxPrice: 2500 },
      { id: 'lock', name: 'Установка / замена замков', minPrice: 1000, maxPrice: 2500 },
      { id: 'mosquito', name: 'Установка москитной сетки', minPrice: 1500, maxPrice: 3000 },
      { id: 'closer', name: 'Установка доводчика', minPrice: 1500, maxPrice: 3000 },
      { id: 'other_windows', name: 'Другая проблема с окнами', minPrice: 0, maxPrice: 0 },
    ],
  },
  {
    id: 'lighting',
    title: 'Освещение и техника',
    iconName: 'Lightbulb',
    iconAsset: '/assets/icons/cat_lighting.svg',
    services: [
      { id: 'chandelier', name: 'Установка люстры / светильника', minPrice: 1500, maxPrice: 4000 },
      { id: 'led', name: 'Монтаж LED-ленты', minPrice: 1500, maxPrice: 3000 },
      { id: 'appliance', name: 'Подключение бытовой техники', minPrice: 1500, maxPrice: 3500 },
      { id: 'tv_setup', name: 'Установка телевизора', minPrice: 1500, maxPrice: 4000 },
      { id: 'wifi', name: 'Настройка Wi-Fi / роутера', minPrice: 1500, maxPrice: 3000 },
      { id: 'other_lighting', name: 'Другая услуга электрика', minPrice: 0, maxPrice: 0 },
    ],
  },
  {
    id: 'express',
    title: 'Экспресс-услуги',
    iconName: 'Zap',
    iconAsset: '/assets/icons/cat_express.svg',
    services: [
      { id: 'hour_master', name: 'Мастер на час', minPrice: 1000, maxPrice: 3000, unit: 'час' },
      { id: 'urgent_visit', name: 'Срочный выезд', minPrice: 0, maxPrice: 0, isUrgentAvailable: true },
      { id: 'small_repair', name: 'Мелкий ремонт до 2 часов', minPrice: 2000, maxPrice: 5000 },
      { id: 'online', name: 'Онлайн-консультация по фото', minPrice: 1000, maxPrice: 2000 },
      { id: 'other_express', name: 'Другая срочная услуга', minPrice: 0, maxPrice: 0 },
    ],
  },
];